import {sbkCoreBreakpointLg} from '@/tokens/variables';
import { css, unsafeCSS } from 'lit';

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
        --citation-teaser-color: var(--_citation-teaser-color, var(--sbkCitationColorFgColorDefault));
        --citation-teaser-bg-color: var(--_citation-teaser-bg-color, var(--sbkCitationColorBgColorMuted));

        --citation-teaser__font-body: var(--sbkCitationTypographySmallScrBody);

        --citation-teaser__padding: var(--sbkCitationSpacingSmallScrInsetTop) var(--sbkCitationSpacingSmallScrInsetRight) var(--sbkCitationSpacingSmallScrInsetBottom) var(--sbkCitationSpacingSmallScrInsetLeft);

        --citation-teaser__gap: var(--sbkCitationSpacingSmallScrGap);

        @media (min-width: ${breakpointLg}) {
            --citation-teaser__font-body: var(--sbkCitationTypographyLargeScrBody);
            --citation-teaser__gap: var(--sbkCitationSpacingLargeScrGap);
            --citation-teaser__padding: var(--sbkCitationSpacingLargeScrInsetTop) var(--sbkCitationSpacingLargeScrInsetRight) var(--sbkCitationSpacingLargeScrInsetBottom) var(--sbkCitationSpacingLargeScrInsetLeft);
        }
    }
    
    :host([size='large']) {
        @media (min-width: ${breakpointLg}) {
            --citation-teaser__font-body: var(--sbkCitationTypographyLargeScrExtraLargeCaseBody);
            --citation-teaser__gap: var(--sbkCitationSpacingLargeScrExtraLargeCaseGap);
            --citation-teaser__padding: var(--sbkCitationSpacingLargeScrExtraLargeCaseInsetTop) var(--sbkCitationSpacingLargeScrExtraLargeCaseInsetRight) var(--sbkCitationSpacingLargeScrExtraLargeCaseInsetBottom) var(--sbkCitationSpacingLargeScrExtraLargeCaseInsetLeft);
        }
    }

    .citation-teaser {
        color: var(--citation-teaser-color);
        border-radius: var(--sbkCitationBorderRadius);
        position: relative;
        overflow: hidden;
        width: 100%;

        @media (min-width: ${breakpointLg}) {
          max-width: var(--sbkCoreContentAreaBodyMaxWidth);
        }
    }

  .citation-teaser--neutral {
    background-color: var(--sbkCitationColorBgColorNeutral);
  }

  .citation-teaser--muted {
    background-color: var(--citation-teaser-bg-color);
  }


  .citation-teaser__content {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--sbkCitationSpacingLargeScrGap);
    padding: var(--citation-teaser__padding);
    z-index: 2;
  }

  .citation-teaser__quote {
    font: var(--citation-teaser__font-body);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    margin: 0;

    slot::slotted(*) {
      margin: 0 !important;
    }

    &.expanded {
      display: block;
      -webkit-box-orient: unset;
      -webkit-line-clamp: unset;
    }
  }

  .citation-teaser__button {
    font: var(--citation-teaser__font-body);
  }

  .citation-teaser__person, .citation-teaser__person-role {
    font: var(--citation-teaser__font-body);
    margin: 0;
  }

  .citation-teaser__quote-icon {
    position: absolute;
    top: 0;
    z-index: 1;
    color: var(--sbkColorContentBgColorDefault);
    right: var(--citation-teaser__gap);
    width: var(--sbkCitationSizingSmallScrBgIconSize);
    height: var(--sbkCitationSizingSmallScrBgIconSize);

    @media (min-width: ${breakpointLg}) {
      width: var(--sbkCitationSizingLargeScrBgIconSize);
      height: var(--sbkCitationSizingLargeScrBgIconSize);
    }
  }

`;
